// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlogMain_wrapper__fIMZ6"};